/**
 * Thrown if a value doesn't exist in the cache
 */
export class ApiCacheMissError extends Error {
}
/**
 * Thrown if a non-200 status response is received
 */
export class ApiError extends Error {
    constructor(status, responseBody, responseType) {
        super(`API Error: ${status}`);
        this.responseBody = responseBody;
        this.status = status;
        this.responseType = responseType;
    }
}
//# sourceMappingURL=errors.js.map